import AgencyRegistration from "../../components/pages/AgencyRegistration";
import AgentHome from "../../components/pages/AgentHome";
import AgentRegistration from "../../components/pages/AgentRegistration";
import Booking from "../../components/pages/Booking";
import CabinSelect from "../../components/pages/CabinSelect";
import Cruise from "../../components/pages/Cruise";
import CurrentBookings from "../../components/pages/CurrentBookings";
import ForgottenPassword from "../../components/pages/ForgottenPassword";
import NickoTermsOfLiability from "../../components/pages/NickoTermsOfLiability";
import Passengers from "../../components/pages/Passengers";
import Payment from "../../components/pages/Payment";
import PaymentConfirmation from "../../components/pages/PaymentConfirmation";
import PreviousBookings from "../../components/pages/PreviousBookings";
import ResetPassword from "../../components/pages/ResetPassword";
import Rooms from "../../components/pages/Rooms";
import Search from "../../components/pages/Search";
import SearchResults from "../../components/pages/SearchResults";
import SignIn from "../../components/pages/SignIn";
import SSOGateway from "../../components/pages/SSOGateway";
import { Brand } from "../../store/slices/environmentSlice";
import { store } from "../../store/store";
import i18n from "../i18n";

import {
  IRouteElement,
  ISideMenuRoute,
  CABINS_SELECT,
  CRUISE,
  PASSENGERS,
  ROOMS,
  ROOT,
  SEARCH_RESULTS,
  SIGN_IN,
  FORGOTTEN_PASSWORD,
  RESET_PASSWORD,
  LOGOUT,
  SEARCH,
  AGENCY_REGISTRATION,
  AGENT_REGISTRATION,
  PAYMENT,
  CURRENT_BOOKINGS,
  BOOKING,
  PREVIOUS_BOOKINGS,
  PAYMENT_CONFIRMATION,
  LIABILITY_AND_CANCELLATION,
  SSO_GATEWAY,
  routeParams,
} from "./routes";

const { t } = i18n;

const PUBLIC_ROUTES: IRouteElement = {
  [SIGN_IN]: { element: SignIn, layout: "auth" },
  [AGENCY_REGISTRATION]: { element: AgencyRegistration, layout: "auth" },
  [AGENT_REGISTRATION]: { element: AgentRegistration, layout: "auth" },
  [FORGOTTEN_PASSWORD]: { element: ForgottenPassword, layout: "auth" },
  [RESET_PASSWORD]: { element: ResetPassword, layout: "auth" },
};

const PRIVATE_ROUTES: IRouteElement = {
  [ROOT]: {
    element: AgentHome,
    layout: "main",
  },
  [SEARCH]: {
    element: Search,
    layout: "auth",
    title: t("search"),
  },
  [SEARCH_RESULTS]: {
    element: SearchResults,
    layout: "search",
    title: t("search results"),
    crumbParams: ["start_date", "end_date"],
  },
  [CRUISE]: {
    element: Cruise,
    layout: "search",
    title: t("number of staterooms"),
    crumbParams: ["start_date", "end_date"],
  },
  [ROOMS]: {
    element: Rooms,
    layout: "search",
    title: t("staterooms"),
    crumbParams: [
      "start_date",
      "end_date",
      "rooms",
      "room",
      "fare_1",
      "grade_1",
      "guests_1",
      "market_1",
    ],
  },
  [CABINS_SELECT]: {
    element: CabinSelect,
    layout: "search",
    title: t("cabins"),
    crumbParams: [
      "start_date",
      "end_date",
      "rooms",
      "room",
      "fare_*",
      "grade_*",
      "guests_*",
      "market_*",
      "cabin_*",
      "deck_*",
    ],
  },
  [PASSENGERS]: {
    element: Passengers,
    layout: "search",
    title: t("passengers"),
  },
  [PAYMENT]: {
    element: Payment,
    layout: "search",
    title: t("payment"),
  },
  [CURRENT_BOOKINGS]: {
    element: CurrentBookings,
    layout: "main",
    title: t("Current bookings"),
  },
  [PREVIOUS_BOOKINGS]: {
    element: PreviousBookings,
    layout: "main",
    title: t("Previous bookings"),
  },
  [BOOKING]: {
    element: Booking,
    layout: "main",
    title: t("Booking"),
  },
  [PAYMENT_CONFIRMATION]: {
    element: PaymentConfirmation,
    layout: "search",
    title: i18n.t("payment_confirmation"),
  },
  [LIABILITY_AND_CANCELLATION]: {
    element: NickoTermsOfLiability,
    layout: "search",
  },
  [SSO_GATEWAY]: {
    element: SSOGateway,
    layout: "auth",
  },
};

const getPublicSideMenu = (): Record<Brand, ISideMenuRoute> => {
  return {
    vid: {},
    default: {},
    dtw: {},
    aov: {},
    cen: {},
  };
};

const getPrivateSideMenu = (): Record<Brand, ISideMenuRoute> => {
  const state = store.getState();

  return {
    vid: {
      [SEARCH]: {
        type: "link",
        label: () => t("book cruise"),
      },

      [routeParams(SSO_GATEWAY, "hotels")]: {
        type: "link",
        label: () => t("Book Hotels"),
        target: "_blank",
      },

      "https://inspires.to/experiences/the-best-of-all-possible-worlds-edw3z7":
        {
          type: "link",
          label: () => t("Approach Guides"),
          target: "_blank",
        },

      [routeParams(SSO_GATEWAY, "cruises")]: {
        type: "link",
        label: () => t("E-Learning"),
        target: "_blank",
      },

      [CURRENT_BOOKINGS]: {
        type: "link",
        label: () => state.environment.current_page_title,
      },
      [PREVIOUS_BOOKINGS]: {
        type: "link",
        label: () => state.environment.previous_page_title,
      },
      "https://vidantaworld.com/en/voyages#faq": {
        type: "link",
        label: () => t("FAQ"),
        target: "_blank",
      },
      [LOGOUT]: {
        type: "button",
        label: () => t("logout"),
      },
    },

    default: {
      [ROOT]: {
        type: "link",
        label: () => t("agent home"),
      },
      [SEARCH]: {
        type: "link",
        label: () => state.environment.start_page_title || t("make a booking"),
      },
      [CURRENT_BOOKINGS]: {
        type: "link",
        label: () => state.environment.current_page_title,
      },
      [PREVIOUS_BOOKINGS]: {
        type: "link",
        label: () => state.environment.previous_page_title,
      },
      [LOGOUT]: {
        type: "button",
        label: () => t("logout"),
      },
    },

    dtw: {
      [ROOT]: {
        type: "link",
        label: () => t("agent home"),
      },
      [SEARCH]: {
        type: "link",
        label: () => state.environment.start_page_title || t("make a booking"),
      },
      [CURRENT_BOOKINGS]: {
        type: "link",
        label: () => state.environment.current_page_title,
      },
      [PREVIOUS_BOOKINGS]: {
        type: "link",
        label: () => state.environment.previous_page_title,
      },
      [LOGOUT]: {
        type: "button",
        label: () => t("logout"),
      },
    },

    aov: {
      [ROOT]: {
        type: "link",
        label: () => t("agent home"),
      },
      [SEARCH]: {
        type: "link",
        label: () => state.environment.start_page_title || t("make a booking"),
      },
      [CURRENT_BOOKINGS]: {
        type: "link",
        label: () => state.environment.current_page_title,
      },
      [PREVIOUS_BOOKINGS]: {
        type: "link",
        label: () => state.environment.previous_page_title,
      },
      [LOGOUT]: {
        type: "button",
        label: () => t("logout"),
      },
    },

    cen: {
      [ROOT]: {
        type: "link",
        label: () => t("agent home"),
      },
      [SEARCH]: {
        type: "link",
        label: () => state.environment.start_page_title || t("make a booking"),
      },
      [CURRENT_BOOKINGS]: {
        type: "link",
        label: () => state.environment.current_page_title,
      },
      [PREVIOUS_BOOKINGS]: {
        type: "link",
        label: () => state.environment.previous_page_title,
      },
      [LOGOUT]: {
        type: "button",
        label: () => t("logout"),
      },
    },
  };
};

const routes = {
  public: PUBLIC_ROUTES,
  private: PRIVATE_ROUTES,
  publicSideMenu: getPublicSideMenu,
  privateSideMenu: getPrivateSideMenu,
};

export default routes;
